import { LoggedService } from './logged.service';
import { CommonService } from 'app/services/common.service';
import { CommonDataSharedService } from 'app/services/commonDataSharedService';
import { RouteDataService } from './route-data.service';
import { CommonRequestResponseService } from './common-request-response.service';
import { WebService } from './web.service';
import { NotificationService } from './notification.service';
import { Injectable } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { AsyncSubject } from 'rxjs';
import { LoginInfo } from '../models';
import { LoginInfoProvider } from '../ev-dal/login-info.provider';
import { MenuService } from './menu.service';

@Injectable({
  providedIn: 'root'
})
export class LoginService {

  loginStatus = false;
  loginData: any;
  logged: any;
  partnerId: any;
  asyncLoginSubject: AsyncSubject<any>;
  asyncLogoutSubject = new AsyncSubject();

  constructor(
    private notificationService: NotificationService,
    private webService: WebService,
    private loginInfoProvider: LoginInfoProvider,
    private _commonRequestResponseService: CommonRequestResponseService,
    private routeDataService: RouteDataService,
    private commonDataSharedService: CommonDataSharedService,
    private _commonService: CommonService,
    private ls: LoggedService,
    public _router: Router,
    private _routes: ActivatedRoute,
    private _menuService: MenuService
  ) { }

  /**
   *@ngdoc method
   *@name saveReferenceType
   *@methodOf reference-list.service
   *@description
   * - This is a method, which is used to save reference type by api call
   @param {object} referenceTypeData
   */
  login(loginObj: any): AsyncSubject<any> {
    this.loginInfoProvider.clearLoginInfo();
    this.asyncLoginSubject = new AsyncSubject<any>();

    this.webService.post('shared/login', loginObj)
      .subscribe(
        response => {
          if (response.errorMessage) {
            this.notificationService.show('error', response.errorMessage);
            this.asyncLoginSubject.error(response.errorMessage);
            this.asyncLoginSubject.complete();
          } else {
            const detailData = [];
            detailData['userRole'] = (response['module']).trim().toLowerCase();
            this.loginData = response;
            this.setLoginData();
            this._commonService.setData(detailData);
            this.commonDataSharedService.loginDatas.next(this.loginData.token)
            this.asyncLoginSubject.next(detailData);
            this.routeDataService.login.next(true);
            this.asyncLoginSubject.complete();
          }
        },
        (error) => {
          this.notificationService.show('error', error.error.errorMessage.replace('Failed to get Login :', ''));
        });

    return this.asyncLoginSubject;
  }

  logout(isInactive?: boolean) {
    const logoutData = {
      partnerId: this._commonRequestResponseService.partnerId,
      userId: this._commonRequestResponseService.loginDetail.userId,
      isInactiveSession: isInactive || false
    };

    this.webService.post('shared/logout', logoutData)
      .subscribe(
        () => {
          localStorage.removeItem('toggleMenu');
          const localPartnerData = JSON.parse(localStorage.getItem('partnerDetail'))
          this.commonDataSharedService.partnerDetailData.next(localPartnerData)
        },
        error => {
          this.notificationService.show('error', `Your session has expired.`);
        });

    this.loginInfoProvider.clearLoginInfo();

    localStorage.removeItem('currentPageData');

    this.loginData = null;
    this.loginStatus = false;
    this._commonRequestResponseService.resetLoginDetail();

    this._router.navigate(['/login'], { relativeTo: this._routes })
      .then()
      .catch(error => {
        console.error('error logging out', error)
      });

    this.routeDataService.logout.next(true);
    this.asyncLogoutSubject.next(true);
    this.asyncLogoutSubject.complete();
    this._menuService.selectMenu(null, { id: 0 });
    return this.asyncLogoutSubject;
  }

  setLoginData() {
    this.logged = {
      userId: this.loginData.userId,
      company: this.loginData.company,
      firstName: this.loginData.firstName,
      lastName: this.loginData.lastName,
      role: this.loginData.role,
      userAccountStatus: 'true',
      avatarURL: '',
      token: this.loginData.token,
      partnerId: this.loginData.partnerId,
      fileUrl: this.loginData.fileUrl,
      classYearDescription: this.loginData.classYearDescription,
      module: this.loginData.module,
      clientId: this.loginData.clientId,
      moduleName: this.loginData.moduleName
    };

    this.partnerId = this.loginData.partnerId;
    this.commonDataSharedService.partnerId.next(this.partnerId);
    this.loginData['isLogin'] = 'true';
    this.loginInfoProvider.loginInfo = (this.loginData as LoginInfo);
    this.ls.setLogged(this.logged);
    this.loginStatus = true;
    this.notificationService.show('success', 'Login successful');
  }
}
